import CheckboxElement from './CheckboxElement';

export default CheckboxElement;
